import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

export default function ProtectedRoute({ token, allowedPath, children }) {
  const previewGroupId = sessionStorage.getItem("previewGroupId");
  const isPreview = Boolean(previewGroupId);

  if (!token) return <Navigate to="/signin" replace />;

  let decoded;
  try {
    decoded = jwtDecode(token);
  } catch {
    return <Navigate to="/signin" replace />;
  }

  const pathname = new URL(decoded.appUrl).pathname;

  if ((pathname === "/ZWAD" && allowedPath === "/ZXUR" && isPreview) || (pathname === "/ZWAD" && allowedPath === "/ZXVO" && isPreview)) {
    return children;
  }

  // Normal access rule
  if (pathname !== allowedPath) {
    return <Navigate to={pathname} replace />;
  }

  return children;
}
